export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function isBlank(obj) {
  if (obj) {
    for (var i in obj) return false;
    return true;  
  } else {
    return true;
  }
}

// return true if d1 > d2
export function isLater(d1, d2) {
  console.log("Inside common/utils.js, [d1, d2] ==> ", [ d1, d2 ])
  const date1 = new Date(d1);
  const date2 = new Date(d2);
  return (date1 > date2);
}

export function shouldUpdateToAIMS(aims_obj, local_obj) {
  return isLater(local_obj.updated_at, aims_obj.updated_at)
}